export const defaultValues = {
  email: '',
  password: '',
};
